export function isCompletedStatusType(statusType) {
  const type = String(statusType || '').toLowerCase();
  return type === 'done' || type === 'closed';
}

export function classifyTaskStatus(status, statusType) {
  if (isCompletedStatusType(statusType)) return 'done';

  const s = String(status || '').toLowerCase();
  if (s.includes('solicitado')) return 'requested';
  if (s.includes('denegado')) return 'denied';
  if (s.includes('aprobado')) return 'approved';
  if (s.includes('por autorizar')) return 'forApproval';
  if (s.includes('confirma recepcion') || s.includes('confirma recepción')) return 'received';
  if (s.includes('garantia') || s.includes('garantía')) return 'warranty';
  if (s.includes('progreso') || s.includes('proceso') || s.includes('in progress')) return 'inProgress';
  if (s.includes('autorizado') || s.includes('done') || s.includes('completed') || s.includes('terminado')) return 'done';
  if (s.includes('review') || s.includes('revisión') || s.includes('revision')) return 'review';
  if (s.includes('blocked') || s.includes('bloqueado')) return 'blocked';
  if (s.includes('rechazado') || s.includes('canceled') || s.includes('cancelado')) return 'canceled';
  if (s.includes('pendiente') || s.includes('to do')) return 'pending';
  if (s === 'open') return 'open';
  return 'pending';
}

export function isCompletedTaskStatus(status, statusType) {
  return isCompletedStatusType(statusType) || classifyTaskStatus(status) === 'done';
}
